import React, { Component } from "react";
import {
	Modal,
	Button,
	Form,
	FormGroup,
	FormControl,
	Col,
	ControlLabel
} from "react-bootstrap";
import PropTypes from "prop-types";
import { Translate, I18n } from "react-i18nify";
import LoginNotification from "./LoginNotification";

// position the modal lower
const modalStyle = {
	position: "static",
	marginTop: 20
};

class Login extends Component {
	constructor(props) {
		super(props);

		this.state = { username: "", password: "", env: "prod" };
		this.handleLogin = this.handleLogin.bind(this);
		this.updateUsername = this.updateUsername.bind(this);
		this.updatePassword = this.updatePassword.bind(this);
		this.updateChangeEnv = this.updateChangeEnv.bind(this);
	}

	handleLogin(e, username, password) {
		e.preventDefault();
		this.props.login(username, password, this.state.env);
	}

	updateUsername(e) {
		this.setState({ username: e.target.value });
	}
	updatePassword(e) {
		this.setState({ password: e.target.value });
	}
	updateChangeEnv(e) {
		this.setState({ env: e.target.value });
	}
	render() {
		const username = this.state.username;
		const password = this.state.password;
		const isLogin = this.props.isLogin;

		return (
			<div className="static-modal">
				<Modal.Dialog style={modalStyle}>
					<Modal.Header>
						<Modal.Title>
							<Translate value="login.login" />
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Form horizontal>
							<FormGroup controlId="formHorizontalEmail">
								<Col componentClass={ControlLabel} sm={3}>
									<Translate value="login.username" />
								</Col>
								<Col sm={9}>
									<FormControl
										type="text"
										placeholder="Utilisateur"
										value={username}
										onChange={this.updateUsername}
									/>
								</Col>
							</FormGroup>

							<FormGroup controlId="formHorizontalPassword">
								<Col componentClass={ControlLabel} sm={3}>
									<Translate value="login.password" />
								</Col>
								<Col sm={9}>
									<FormControl
										type="password"
										placeholder="Mot de passe"
										value={password}
										onChange={this.updatePassword}
									/>
								</Col>
							</FormGroup>
							<FormGroup controlId="formHorizontalSelect">
								<Col componentClass={ControlLabel} sm={3}>
									<Translate value="login.environment" />
								</Col>
								<Col sm={9}>
									<FormControl
										componentClass="select"
										placeholder="select"
										style={{ marginBottom: 15 }}
										onChange={this.updateChangeEnv}
									>
										<option value="prod">
											{I18n.t("login.envProd")}
										</option>
										<option value="test">
											{I18n.t("login.envTest")}
										</option>
									</FormControl>
								</Col>
							</FormGroup>
							<FormGroup>
								<Col sm={12}>
									<Button
										className="float-right"
										disabled={
											isLogin ||
											!username.length ||
											!password.length ||
											this.state.env === "empty"
										}
										type="submit"
										onClick={e =>
											this.handleLogin(
												e,
												username,
												password
											)
										}
									>
										<Translate value="login.signin" />
									</Button>
								</Col>
							</FormGroup>
						</Form>
					</Modal.Body>
				</Modal.Dialog>
				<LoginNotification
					loginAnnouncement={this.props.loginAnnouncement}
				/>
			</div>
		);
	}
}

Login.propTypes = {
	login: PropTypes.func.isRequired,
	isLogin: PropTypes.bool.isRequired
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/views/login/Login.js